export default __webpack_public_path__ + "images/f0cc2d1dec2db528746c670607170f8e.svg";